import Component from "components/Component";
import { makeSearch } from "components/search/SearchTextField";
import * as config from "config";
import * as labels from "config.labels";
import * as staticDataHooks from "store/hooks/staticDataHooks";

const CategoryCodeSearch = makeSearch((state) => ({
  searchState: state.search.categoryCode,
  active: state.input.program.categoryCode,
  meta: config.CATEGORY_CODE_SEEKER,
  displayResultText: (result) => `(${result._CODE}) ${result._TITLE}`,
  renderValue: (result) => `(${result.code}) ${result.title}`,
}));

const CategoryCode = (props) => {
  const translateLabel = staticDataHooks.useTranslator("uiLabels");

  const categoryCodeSearchLabel = translateLabel(labels.CATEGORY_CODE_LABEL, {
    default: "GICS Code",
  });

  return (
    <Component
      title={translateLabel(labels.CATEGORY_CODE_TITLE, {
        default: "GICS Code",
      })}
      subtitle={translateLabel(labels.CATEGORY_CODE_SUBTITLE, {
        default: "The Global Industry Classification Standard",
      })}
      {...props.componentProps}
    >
      <CategoryCodeSearch label={categoryCodeSearchLabel} />
    </Component>
  );
};

export default CategoryCode;
